// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"405":"1530fcfd","582":"b0f70557"}[chunkId] + ".chunk.css";
};